import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_auto_complete, {
      value: _ctx.name,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
      options: _ctx.records,
      backfill: "",
      allowClear: "",
      onChange: _ctx.onSelectName
    }, {
      option: _withCtx((item) => [
        _createElementVNode("div", {
          onClick: ($event: any) => (_ctx.onChange(item))
        }, _toDisplayString(item.name), 9, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: _ctx.name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          placeholder: "请输入或选择联系人",
          maxlength: 10,
          autocomplete: "off",
          style: {"width":"100%"}
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["value", "options", "onChange"])
  ]))
}